/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { connect } from 'react-redux';
import { Constants, Globals, axios } from '../../utils';
import { Input, Select, Modal } from '../../components';
import { PublicStoreService, QuoteService } from '../../services';
import NumberFormat from 'react-number-format';
import TrashIcon from '../../assets/icons/trash.png';

class ConvertToOrder extends React.Component {

	state = {
		methods: [],
		form: {
			method_id: '',
			file: '',
			initial_payment: '',
			status: this.props?.item?.status_payment || Constants.PAYMENT_TYPES.PAID,
			show_taxes: Constants.QUOTES.SHOW_TAXES.NO,
			discount_percentage: this.props?.item?.discounts?.find(d => d.general_discount_id === null)?.porcentage || 0,
			discount: this.props?.item?.discount || 0,
			credit_days: this.props?.item?.credit_days || '',
			information: this.props?.item?.comments || '',
			iva: null,
			iva_bs: null,
			client_id: this.props?.item?.client_id || this.props?.client?.id || '',
			general_discounts: [],
			subtotal: 0,
			total: 0
		},
		dates: [],
		visible_dates: false,
		order: this.props.item,
		config: null,
		height: 0,
		methods_selected: [],
		disabled_button: false,
		quote: this.props.quote ?? false,
		exchangeRate: 0,
		countryEquivalent: Globals.getUserCountryEquivalent(),
		IVA: Globals.getAdminIva(),
		loadingConfig: true,
		discountsRules: [],
		general_discounts: [],
	}

	componentDidMount = async () => {
		console.log(this.props.item)
		await this.getConfig();
		await this.getExchangeRate();
		await this.getNewDiscounts();
		await this.getAdminGeneralDiscounts();

		const details = (this.props?.item?.details || []).filter(i => i.product && !i.product.deleted_at).reduce((acc, x) => {
			const existingIndex = acc.findIndex(item =>
				item.product_id === x.product_id &&
				item.size_id === x.size_id &&
				item.color_id === x.color_id
			);

			if (existingIndex !== -1) {
				const existing = acc[existingIndex];
				existing.quantity = (parseFloat(existing.quantity) + parseFloat(x.quantity)).toString();
				existing.product.quantity = existing.quantity;

				const currPrice = parseFloat(x.price ?? x.sale_price);
				const existingPrice = parseFloat(existing.selected_price);
				if (currPrice > existingPrice) {
					existing.price = x.price;
					existing.selected_price = currPrice;
					existing.product.selected_price = currPrice;
				}
			} else {
				const product = Globals.copy(x.product);
				product.quantity = x.quantity;

				// El descuento manual es el registro en discounts con discount_id nulo
				let manualDisc = 0;
				if (x.discounts && x.discounts.length > 0) {
					const manualObj = x.discounts.find(d => d.discount_id === null);
					if (manualObj) manualDisc = parseFloat(manualObj.porcentage);
				} else if (!isNaN(Number(x.discount_percentage)) && String(x.discount_percentage).trim() !== '') {
					manualDisc = Number(x.discount_percentage);
				}

				product.discount_percentage = manualDisc;
				x.discount_percentage = manualDisc;
				x.discount = manualDisc;
				product.size_id = x.size_id;
				product.color_id = x.color_id;

				// Al convertir una cotización a pedido, los precios ya reflejan las reglas
				// aplicadas al momento de cotizar. No se deben recalcular con los valores
				// actuales de las reglas (que pueden haber cambiado), sino respetar el precio pactado.
				product.skip_auto_rules = true;

				// Mantenemos esto como float para cálculos matemáticos precisos
				const rawPrice = x.price ?? x.sale_price;
				product.selected_price = parseFloat(rawPrice);
				x.selected_price = product.selected_price;
				// Añadimos original_price también por si acaso otros componentes lo buscan
				product.original_price = product.selected_price;
				x.original_price = product.selected_price;

				acc.push({ ...x, product });
			}
			return acc;
		}, []);

		const show_taxes = this.props?.item?.show_taxes || Constants.QUOTES.SHOW_TAXES.NO;

		await this.setState({
			form: {
				...this.state.form,
				show_taxes,
			},
			order: {
				...this.state.order,
				show_taxes,
				details,
			},
			loadingConfig: false
		});

		this.setTotals();
	}

	getAdminGeneralDiscounts = async () => {
		const item = this.props.item;
		await axios
			.post("admin/profile/generaldiscounts/get", { user_id: this.props.user.id, last_three: true })
			.then(({ data }) => {
				// Construir general_discounts directamente desde item.discounts
				// para capturar TODOS los descuentos generales guardados (incluyendo reglas como "Remate por inventario")
				const general_discounts = (item?.discounts || [])
					.filter(d => d.general_discount_id !== null)
					.map(d => ({ discount_id: d.general_discount_id, value: d.porcentage }));

				this.setState({
					general_discounts: data.discounts,
					form: {
						...this.state.form,
						general_discounts
					}
				}, () => this.setTotals());
			})
			.catch(() => Globals.showError())
	}

	getNewDiscounts = async () => {
		try {
			const response = await axios.post('admin/discounts/get', { user_id: this.props.user.id, all: true, status: Constants.STATUS_ACTIVE });
			if (response.data && response.data.discounts) {
				this.setState({ discountsRules: response.data.discounts }, () => this.setTotals());
			}
		} catch (error) {
			console.error("Error al obtener los descuentos", error);
		}
	}

	changeGeneralDiscount = async (discountId, value) => {
		await this.setState(state => {
			const general_discounts = [...state.form.general_discounts];
			const index = general_discounts.findIndex(d => d.discount_id === discountId);
			if (index >= 0) {
				general_discounts[index] = { ...general_discounts[index], value };
			} else {
				general_discounts.push({ discount_id: discountId, value });
			}
			return { form: { ...state.form, general_discounts } };
		});
		this.setTotals();
	}

	getConfig = async () => {
		try {
			const { data } = await axios.post("sync/config", { user_id: this.props.user.id });
			await new Promise(resolve => this.setState({ config: data.config }, resolve));
		} catch (error) {
			Globals.showError();
		}
	};

	getExchangeRate = async () => {
		try {
			const filter = { user_id: this.props.user.id };
			const res = await axios.post('admin/conversions', filter);
			if (!res.data?.conversion) throw Error('Debe establecer una tasa de cambio para continuar');
			this.setState({ exchangeRate: res.data?.conversion?.amount || 0 });
		} catch (error) {
			Globals.showError(error?.message);
		}
	};

	getDecimals = () => {
		const { config } = this.state;
		return (config?.three_decimals == Constants.STATUS_ACTIVE || config?.three_decimals === true || config?.three_decimals == "1") ? 3 : 2;
	}

	parse = (value) => {
		return parseFloat(parseFloat(value || 0).toFixed(this.getDecimals()));
	}

	setPaymentType = (status) => {
		this.setState({ form: { ...this.state.form, status } });
	}

	change = async (value, target) => {
		await this.setState({ form: { ...this.state.form, [target]: value } });
		if (['discount_percentage', 'show_taxes', 'credit_days', 'client_id'].includes(target)) {
			this.setTotals();
		}
	}

	changeValue = async (value, target, index) => {
		let details = [...this.state.order.details];
		if (target === 'discount') {
			details[index].product.discount_percentage = value;
			details[index].discount_percentage = value;
		} else {
			details[index][target] = value;
			details[index].product[target] = value;
		}
		await this.setState({ order: { ...this.state.order, details } });
		this.setTotals();
	}

	checkedChange = async (newValue) => {
		await this.setState(prevState => ({
			form: {
				...prevState.form,
				show_taxes: newValue === true ? Constants.QUOTES.SHOW_TAXES.YES : Constants.QUOTES.SHOW_TAXES.NO
			}
		}));
		this.setTotals();
	}

	submit = async () => {
		const decimals = this.getDecimals();
		const total = this.state.form.total;

		if (this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY && this.state.form.credit_days <= 0) {
			Globals.showError("Debe ingresar los días de crédito");
			this.enableSubmit();
			return false;
		}

		if (this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY && this.state.form.initial_payment >= total) {
			Globals.showError("El pago inicial no puede ser igual o mayor al monto total.");
			this.enableSubmit();
			return false;
		}

		if (this.state.form.discount_ !== '' && this.state.form.discount_ > 100) {
			Globals.showError("El porcentaje de descuento general no puede ser mayor a 100%");
			this.enableSubmit();
			return false;
		}

		if (this.state.config?.negative_stock !== Constants.CONFIG.YES) {
			const detail = this.state.order.details.find((i) => {
				const qty = parseFloat(String(i.quantity).replace(',', '.'));
				if (i.product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
					const size_color = i.product?.size_colors?.find((_i) => {
						const s_id = i.size_id || null;
						const c_id = i.color_id || null;
						return _i.size_id == s_id && _i.color_id == c_id;
					});
					return size_color?.stock < qty;
				}
				return i.product.stock < qty;
			});

			if (detail) {
				Globals.showError(`Stock insuficiente para: ${detail.product.name}`);
				this.enableSubmit();
				return false;
			}
		}

		if (this.state.form.status !== Constants.PAYMENT_TYPES.TO_PAY || this.state.form.initial_payment !== '') {
			if (this.state.methods_selected.length === 0) {
				Globals.showError("Debe seleccionar al menos 1 método de pago");
				this.enableSubmit();
				return false;
			}

			let targetAmount = this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY ? this.state.form.initial_payment : total;
			let paidSum = this.state.methods_selected.reduce((a, b) => a + parseFloat(b.amount || 0), 0);

			if (this.parse(paidSum) !== this.parse(targetAmount)) {
				Globals.showError(`La suma de pagos (${Globals.formatMiles(paidSum, decimals)}) debe coincidir con el total (${Globals.formatMiles(targetAmount, decimals)})`);
				this.enableSubmit();
				return false;
			}
		}

		Globals.setLoading();
		try {
			const payload = {
				registered_by: this.props.user?.id,
				seller_id: this.props.user?.id,
				client_id: this.props.client?.id,
				admin_id: this.props.user?.level_id === Constants.ROLE_ADMIN ? this.props.user?.id : this.props.user?.admin_id,
				currency: this.props.currency,
				...this.state.form,
				discount: this.state.form.discount_percentage || 0,
				general_discounts: this.state.form.general_discounts,
				details: JSON.stringify(this.state.order.details),
				methods_selected: JSON.stringify(this.state.methods_selected),
			};

			let res;
			if (this.state.quote === true) {
				res = await QuoteService.convertToOrder({ ...payload, quote_id: this.state.order?.id });
			} else {
				res = await PublicStoreService.convertToOrder({ ...payload, order_id: this.state.order?.id });
			}

			if (res?.result === false) {
				Globals.showError(res?.error ?? 'Error al procesar el pedido');
			} else {
				Globals.showSuccess("Se ha enviado el pedido correctamente");
				this.props.onClose(true);
			}
		} catch (error) {
			Globals.showError('Ocurrió un error al guardar el pedido');
		}
		Globals.quitLoading();
	}

	enableSubmit = () => {
		this.setState({ disabled_button: false });
	}

	setTotals = async () => {
		const { exchangeRate, form, discountsRules } = this.state;
		const details = this.state.order?.details || [];
		const decimals = this.getDecimals();
		const parse = this.parse;
		const IVA = this.state.IVA || Globals.getAdminIva();

		const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);
		const checkIsBultoCajaCestaUnidad = (prod) => Globals.checkIsBultoCajaCestaUnidad(prod, isOdooUser);
		// Volumen: solo bultos/cajas/cestas (excluye "Unidad")
		const checkIsBultoCajaCesta = (prod) => Globals.checkIsBultoCajaCesta(prod, isOdooUser);
		let subtotal_usd = 0;
		let original_subtotal_usd = 0;
		let totalDiscountAmount = 0;

		let new_general_discounts = [];

		if (discountsRules && discountsRules.length > 0) {
			discountsRules.forEach(master => {
				if (master.status !== 1) return;

				// Descuento General
				if (master.type === 'general') {
					// Buscamos si el usuario especificó un porcentaje en el estado
					const userDiscount = form.general_discounts.find(d => d.discount_id === master.id);
					if (userDiscount && userDiscount.value !== '') {
						new_general_discounts.push({
							discount_id: master.id,
							value: userDiscount.value
						});
					}
				}

				// Pronto Pago
				if (master.type === 'pronto_pago' && form.status === Constants.PAYMENT_TYPES.TO_PAY && form.client_id && form.credit_days) {
					const days = parseInt(form.credit_days);
					const clientId = form.client_id;
					if (!isNaN(days) && days > 0 && clientId) {
						master.discount_details.forEach(rule => {
							if (rule.client_id == clientId && days <= rule.max_days) {
								new_general_discounts.push({ discount_id: master.id, value: parseFloat(rule.percentage) });
							}
						});
					}
				}
			});
		}

		const cartProductIds = details.map(item => item.product_id || item.product?.id);

		let iva_usd = 0;
		let iva_bs = 0;

		for (const item of details) {
			const product = item.product;
			if (!product) continue;

			const qty = parseFloat(String(item.quantity).replace(',', '.')) || 0;
			const originalPrice = parseFloat(item.selected_price || product.selected_price || product.sale_price || product.price || 0);

			let appliedPrice = originalPrice;
			let itemPercentageDiscount = 0;
			let applied_rules = [];

			// Evaluar reglas de descuento automáticas
			// (solo si el precio no viene de una cotización guardada)
			if (!product.skip_auto_rules && discountsRules && discountsRules.length > 0) {
				let allApplicableVolumenRules = [];
				discountsRules.forEach(master => {
					if (master.status !== 1) return;
					if (!master.discount_details) return;

					let rutaVendedorApplied = false;

					master.discount_details.forEach(rule => {
						const prodId = item.product_id || product.id;

						if (master.type === 'limite_cantidad' && rule.product_id === prodId) {
							if (qty <= rule.max_quantity) {
								appliedPrice = parseFloat(rule.special_price);
								product.special_price_applied = true;
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: 'Especial' });
							} else if (rule.max_quantity && qty > rule.max_quantity) {
								const specialQty = parseFloat(rule.max_quantity);
								const regularQty = qty - specialQty;
								appliedPrice = ((specialQty * parseFloat(rule.special_price)) + (regularQty * originalPrice)) / qty;
								product.special_price_applied = true;
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: 'Especial' });
							}
						}

						if (master.type === 'volumen') {
							if ((rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === product.category_id)) && qty >= rule.min_quantity) {
								allApplicableVolumenRules.push({ rule, master });
							}
						}

						if (master.type === 'ruta_vendedor' && rule.product_id === (product.product_id || product.id) && !rutaVendedorApplied) {
							const activeSeller = this.props.item?.seller || this.props.user;
							const sellerId = activeSeller ? activeSeller.id : null;
							let isInZone = false;
							if (rule.zone_id && activeSeller) {
								if (activeSeller.zones && activeSeller.zones.length > 0) {
									isInZone = activeSeller.zones.some(z => z.id == rule.zone_id || z.zone_id == rule.zone_id);
								} else if (activeSeller.zone_id == rule.zone_id) {
									isInZone = true;
								}
							}

							if (isInZone || (rule.seller_id && rule.seller_id == sellerId)) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
								rutaVendedorApplied = true;
							}
						}

						if (master.type === 'surtido' && rule.product_id === (product.product_id || product.id)) {
							let distinctCount = 0;
							master.discount_details.forEach(surtidoRule => {
								if (surtidoRule.counts_for_calculation && cartProductIds.includes(surtidoRule.product_id)) distinctCount++;
							});

							if (distinctCount >= rule.min_quantity) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
							}
						}
						if (master.type === 'surtido_volumen' && (rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === (product.category_id || product.category?.id)))) {
							const isProductBulto = checkIsBultoCajaCestaUnidad(product);
							if (isProductBulto) {
								let participatingCartProdIds = [];
								let totalBultos = 0;

								details.forEach(cartProd => {
									const isCartProdBulto = checkIsBultoCajaCestaUnidad(cartProd);
									const cProdId = cartProd.product_id || cartProd.product?.id;
									const cCatId = cartProd.product?.category_id || cartProd.product?.category?.id;
									const isParticipating = master.discount_details.some(svRule =>
										(svRule.product_id === cProdId || (svRule.category_id && svRule.category_id === cCatId))
										&& svRule.counts_for_calculation
									);
									if (isParticipating && isCartProdBulto) {
										// Surtido (SKU distintos): incluye "Unidad"
										if (!participatingCartProdIds.includes(cProdId)) {
											participatingCartProdIds.push(cProdId);
										}
									}
									if (isParticipating && checkIsBultoCajaCesta(cartProd)) {
										// Volumen (total bultos/cajas/cestas): NO incluye "Unidad"
										const qtyProd = parseFloat(String(cartProd.quantity).replace(',', '.')) || 0;
										totalBultos += qtyProd;
									}
								});

								let distinctCount = participatingCartProdIds.length;
								const meetsSku = distinctCount >= rule.min_sku;
								const meetsBultos = totalBultos >= rule.min_bultos;

								if (meetsSku && meetsBultos) {
									const pctOne = parseFloat(rule.percentage_one_condition);
									const pctBoth = parseFloat(rule.percentage_both_conditions);
									if (meetsSku !== meetsBultos)
									if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctOne;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
									}
									if (!isNaN(pctBoth) && pctBoth > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctBoth;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctBoth });
									}
								} else if (meetsSku || meetsBultos) {
									const pctOne = parseFloat(rule.percentage_one_condition);
									if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctOne;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
									}
								}
							}
						}

					});
				});

				if (allApplicableVolumenRules.length > 0) {
					const categoryRules = allApplicableVolumenRules.filter(item => item.rule.category_id && item.rule.category_id === product.category_id);
					const rulesToApply = categoryRules.length > 0 ? categoryRules : allApplicableVolumenRules;

					rulesToApply.forEach(item => {
						itemPercentageDiscount += parseFloat(item.rule.percentage);
						applied_rules.push({ discount_id: item.master.id, name: item.master.name, percentage: parseFloat(item.rule.percentage) });
					});
				}
			} else if (product.skip_auto_rules) {
				// Recuperar reglas aplicadas previamente en la cotización
				if (item.discounts && item.discounts.length > 0) {
					item.discounts.forEach(d => {
						if (d.discount_id !== null) {
							itemPercentageDiscount += parseFloat(d.porcentage);
							applied_rules.push({ discount_id: d.discount_id, name: d.discount?.name || 'Descuento', percentage: parseFloat(d.porcentage) });
						}
					});
				} else if (product.applied_discounts && product.applied_discounts.length > 0) {
					product.applied_discounts.forEach(ad => {
						itemPercentageDiscount += parseFloat(ad.percentage);
						applied_rules.push(ad);
					});
				}

				// Preservar la información si se aplicó precio especial
				if (item.special_price_applied || product.special_price_applied) {
					// No tenemos forma de saber exactamente la regla sin volverla a evaluar, pero la marcamos
					product.special_price_applied = true;
					const priceLabel = { discount_id: 'especial', name: 'Precio Especial', percentage: 'Especial' };
					if (!applied_rules.find(r => r.percentage === 'Especial')) {
						applied_rules.push(priceLabel);
					}
				}
			}

			if (itemPercentageDiscount > 100) itemPercentageDiscount = 100;

			// Descuento manual del producto
			const manualDiscount = parseFloat(item.discount_percentage || item.discount || product.discount_percentage || 0);

			let finalUnitPrice = appliedPrice;

			if (manualDiscount > 0) {
				let manualDesc = manualDiscount;
				if (manualDesc > 100) manualDesc = 100;
				finalUnitPrice -= (finalUnitPrice * (manualDesc / 100));
			}

			if (applied_rules.length > 0) {
				applied_rules.forEach(ar => {
					if (ar.percentage === 'Especial') return;
					let ruleDesc = parseFloat(ar.percentage);
					if (!isNaN(ruleDesc) && ruleDesc > 0) {
						if (ruleDesc > 100) ruleDesc = 100;
						finalUnitPrice -= (finalUnitPrice * (ruleDesc / 100));
					}
				});
			}

			if (finalUnitPrice < 0) finalUnitPrice = 0;

			// String de descuento para visualización
			let manualDesc = manualDiscount;
			if (manualDesc > 100) manualDesc = 100;
			const numericAutoRules = applied_rules.filter(r => r.percentage !== 'Especial');
			const autoDiscountStr = numericAutoRules.map(r => `${r.percentage}%`).join(' / ');
			if (manualDesc > 0 && numericAutoRules.length > 0) {
				product.discount_str = `${manualDesc}% / ${autoDiscountStr}`;
			} else if (manualDesc > 0) {
				product.discount_str = `${manualDesc}%`;
			} else if (numericAutoRules.length > 0) {
				product.discount_str = autoDiscountStr;
			} else {
				product.discount_str = '';
			}

			if (!product.skip_auto_rules) {
				product.applied_discounts = applied_rules;
			}

			let lineSubtotal = parse(finalUnitPrice * qty);
			if (lineSubtotal < 0) lineSubtotal = 0;

			item.subtotal = lineSubtotal;
			product.subtotal = lineSubtotal;

			const lineOriginalSubtotal = parse(originalPrice * qty);
			original_subtotal_usd += parse(lineOriginalSubtotal);
			subtotal_usd += parse(lineSubtotal);

			if (form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && product.exento == Constants.PRODUCT_EXENTO.NO) {
				iva_usd += parse(lineSubtotal);
				iva_bs += parse(lineSubtotal * exchangeRate);
			}
		}

		let currentSubtotal = subtotal_usd;

		// Descuento principal
		if (form.discount_percentage > 0) {
			let desc = parseFloat(form.discount_percentage);
			if (desc > 100) desc = 100;
			currentSubtotal -= (currentSubtotal * (desc / 100));
		}

		// Descuentos generales
		new_general_discounts.forEach(gd => {
			let desc = parseFloat(gd.value);
			if (desc > 100) desc = 100;
			currentSubtotal -= (currentSubtotal * (desc / 100));
		});

		if (currentSubtotal < 0) currentSubtotal = 0;

		totalDiscountAmount = subtotal_usd - currentSubtotal;
		const totalDiscountPercentage = totalDiscountAmount > 0 ? (totalDiscountAmount / subtotal_usd) * 100 : 0;

		let final_iva_usd = 0;
		let final_iva_bs = 0;

		if (form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES) {
			if (totalDiscountPercentage > 0) {
				const discountOnIvaUsd = iva_usd * (totalDiscountPercentage / 100);
				iva_usd -= discountOnIvaUsd;
				iva_bs -= (discountOnIvaUsd * exchangeRate);
			}
			final_iva_usd = parse((iva_usd * IVA) / 100);
			final_iva_bs = parse((iva_bs * IVA) / 100);
			currentSubtotal += final_iva_usd;

			// Asignar el IVA correspondiente a cada producto para la vista
			details.forEach(item => {
				const product = item.product || item;
				if (product.exento == Constants.PRODUCT_EXENTO.NO) {
					const discountedSubtotal = item.subtotal * (1 - (totalDiscountPercentage / 100));
					item.iva = parse((discountedSubtotal * IVA) / 100);
					if (item.product) item.product.iva = item.iva;
				} else {
					item.iva = 0;
					if (item.product) item.product.iva = 0;
				}
			});
		} else {
			details.forEach(item => {
				item.iva = 0;
				if (item.product) item.product.iva = 0;
			});
		}

		// Construir appliedDiscountsRules agrupando los descuentos por producto
		const appliedDiscountsRulesMap = {};
		details.forEach(item => {
			const product = item.product || item;
			if (!product.applied_discounts || product.applied_discounts.length === 0) return;
			const qty = parseFloat(String(item.quantity).replace(',', '.')) || 0;
			const origPrice = parseFloat(item.selected_price || product.selected_price || product.sale_price || product.price || 0);
			let runningSubtotal = qty * origPrice;
			const manualDiscVal = parseFloat(item.discount_percentage || item.discount || product.discount_percentage || 0);
			if (manualDiscVal > 0) {
				const manualDesc = manualDiscVal > 100 ? 100 : manualDiscVal;
				runningSubtotal -= runningSubtotal * (manualDesc / 100);
			}

			product.applied_discounts.forEach(ad => {
				if (ad.percentage === 'Especial') return;
				const mapKey = `${ad.discount_id}_${ad.percentage}`;
				if (!appliedDiscountsRulesMap[mapKey]) {
					appliedDiscountsRulesMap[mapKey] = {
						id: ad.discount_id,
						name: ad.name,
						percentage: parseFloat(ad.percentage),
						totalAmount: 0,
					};
				}
				const pct = parseFloat(ad.percentage) > 100 ? 100 : parseFloat(ad.percentage);
				const ruleAmount = runningSubtotal * (pct / 100);
				runningSubtotal -= ruleAmount;
				appliedDiscountsRulesMap[mapKey].totalAmount = parse(
					appliedDiscountsRulesMap[mapKey].totalAmount + parse(ruleAmount)
				);
			});
		});

		// Construir appliedDiscountsGeneral (descuentos globales)
		const appliedDiscountsGeneral = [];
		const allGlobalDiscounts = [];
		if (form.discount_percentage > 0) {
			allGlobalDiscounts.push({ discount_id: null, value: parseFloat(form.discount_percentage) });
		}
		new_general_discounts.forEach(gd => {
			allGlobalDiscounts.push(gd);
		});

		allGlobalDiscounts.forEach(gd => {
			const masterInfo = discountsRules?.find(r => r.id === gd.discount_id);
			appliedDiscountsGeneral.push({
				id: gd.discount_id,
				name: gd.discount_id == null ? 'Descuento' : masterInfo?.name || 'Descuento General',
				percentage: parseFloat(gd.value),
				totalAmount: 0,
			});
		});

		if (appliedDiscountsGeneral.length > 0) {
			let cascadeSubtotal = subtotal_usd;
			appliedDiscountsGeneral.forEach(gd => {
				let desc = parseFloat(gd.percentage);
				if (desc > 100) desc = 100;
				const discountAmount = cascadeSubtotal * (desc / 100);
				gd.totalAmount = parse(discountAmount);
				cascadeSubtotal -= discountAmount;
			});
		}

		const appliedDiscountsRules = Object.values(appliedDiscountsRulesMap).concat(appliedDiscountsGeneral);

		await this.setState({
			appliedDiscountsRules,
			original_subtotal_usd: parse(original_subtotal_usd),
			form: {
				...this.state.form,
				subtotal: parse(subtotal_usd),
				discount: parse(totalDiscountAmount),
				iva: final_iva_usd,
				iva_bs: final_iva_bs,
				total: parse(currentSubtotal),
				general_discounts: new_general_discounts
			},
		});
	}

	// Cambiamos el redondeo por truncación lógica
	truncParse = (value) => {
		const decimals = this.getDecimals(); // Obtiene 2 o 3 según configuración
		const multiplier = Math.pow(10, decimals);
		// Math.floor(94.414999 * 1000) -> 94414 -> / 1000 -> 94.414
		return Math.floor(value * multiplier) / multiplier;
	}

	changeValue = async (value, target, index) => {
		let details = [...this.state.order.details];
		const product = details[index].product;

		if (target === 'quantity') {
			if (product.decimal_stock == Constants.DECIMAL_STOCK.NO) {
				value = value.replace(/\D/g, '');
			} else {
				const parts = value.split(',');
				if (parts.length > 2) return;
			}
			// Al cambiar cantidad, re-evaluar reglas (volumen, etc.)
			product.skip_auto_rules = false;
		}

		if (target === 'selected_price') {
			// Al cambiar precio manualmente, re-evaluar reglas con el nuevo precio base
			product.skip_auto_rules = false;
			product.selected_price = parseFloat(value);
		}

		if (target === 'discount') {
			product.discount_percentage = value;
			details[index].discount_percentage = value;
		}

		details[index][target] = value;
		product[target] = value;

		await this.setState({ order: { ...this.state.order, details } });
		this.setTotals();
	}

	// CORRECCIÓN PRINCIPAL AQUÍ
	getPricesOLD = (product) => {
		console.log('product: ', product)
		let prices = product.prices || [];
		const decimals = this.getDecimals();

		if (product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
			const size_color = product?.size_colors?.find((i) => {
				const s_id = product.size_id || null;
				const c_id = product.color_id || null;
				return i.size_id == s_id && i.color_id == c_id;
			});
			prices = size_color?.prices || [];
		}

		const basePrice = product.selected_price || product.sale_price || 0;

		return [
			{
				value: parseFloat(basePrice),
				// TRUCO: Pasamos basePrice como STRING con decimales fijos a formatMiles.
				// Esto engaña a la función si trata distinto a Strings y Números,
				// y asegura que visualmente se vean los 3 decimales (12.567).
				label: `$${Globals.formatMiles(parseFloat(basePrice).toFixed(decimals))}`,
			},
			...prices.map(i => ({
				value: parseFloat(i.price),
				// i.price ya viene como string desde DB, por eso funcionaba bien.
				// Aun así, lo aseguramos con toFixed también si hiciera falta, 
				// pero formatMiles(string) suele respetar el input.
				label: `$${Globals.formatMiles(i.price, decimals)}`,
			}))
		]
	}

	getPrices = (product) => {
		let size_color = null;
		let prices = product.prices;

		if (product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
			size_color = product?.size_colors?.find((i) => {
				if (product.size_id && product.color_id) {
					return i.size_id === product.size_id && i.color_id === product.color_id;
				}
				else if (product.size_id) {
					return i.size_id === product.size_id && !i.color_id;
				}
				else if (product.color_id) {
					return i.color_id === product.color_id && !i.size_id;
				}

				return null;
			});

			prices = size_color?.prices || [];
			product.price = (product?.size_colors.length > 0 ? product?.size_colors[0].sale_price : 0);

		} else {
			product.price = product.sale_price;
		}

		return [
			{
				value: parseFloat(size_color?.sale_price || product.price), // Convertimos a número
				label: `$${Globals.formatMiles(size_color?.sale_price || product.price, true)}`,
			},
			...prices.map(i => ({
				value: parseFloat(i.price), // Convertimos a número
				label: `$${Globals.formatMiles(i.price, true)}`,
			}))
		]
	}

	render() {
		if (this.state.loadingConfig) {
			return <div className="p-4 text-center">Cargando configuración...</div>;
		}

		const decimals = this.getDecimals();

		// Calcular descuentos automáticos aplicados
		const appliedAutomaticDiscounts = [];
		const details = this.state.order?.details || [];

		details.forEach(item => {
			const product = item.product;
			if (!product) return;

			if (product.applied_discounts && product.applied_discounts.length > 0) {
				product.applied_discounts.forEach(ad => {
					const existing = appliedAutomaticDiscounts.find(d => d.name === ad.name && d.percentage === ad.percentage);
					if (!existing) {
						appliedAutomaticDiscounts.push({
							name: ad.name,
							percentage: ad.percentage,
							icon: 'fa fa-cube'
						});
					}
				});
			}
			if (product.special_price_applied) {
				const existing = appliedAutomaticDiscounts.find(d => d.name === 'Precio Especial');
				if (!existing) {
					appliedAutomaticDiscounts.push({
						name: 'Precio Especial',
						percentage: 'Especial',
						icon: 'fa fa-tag'
					});
				}
			}
		});

		if (this.state.form.general_discounts && this.state.form.general_discounts.length > 0) {
			this.state.form.general_discounts.forEach(gd => {
				const ruleInfo = this.state.discountsRules?.find(r => r.id === gd.discount_id);
				if (ruleInfo && ruleInfo.type !== 'general') {
					appliedAutomaticDiscounts.push({
						name: ruleInfo.name,
						percentage: gd.value,
						icon: 'fa fa-clock-o'
					});
				}
			});
		}

		return (
			<React.Fragment>
				<div className="whatsapp-convert-to-order">
					<div className="product-list">
						{this.state.order && this.state.order.details.map((item, index) => {
							const product = item.product;
							if (!product) return null;

							const qty = parseFloat(String(item.quantity).replace(',', '.')) || 0;
							const price = item.selected_price || 0;
							console.log(price)

							let rowSubtotal = product.subtotal !== undefined ? product.subtotal : this.parse(price * qty);
							if (this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && product.exento == Constants.PRODUCT_EXENTO.NO && item.iva != null) {
								rowSubtotal = this.parse(rowSubtotal + item.iva);
							}
							// Usamos toFixed aquí también para asegurar visualización en la descripción
							let label_details = `${qty} x ${Globals.newFormatMiles(price, decimals)}`;

							let discountStr = '';
							if (product.discount_str != null && product.discount_str !== '') {
								discountStr = product.discount_str;
							} else if (item.discount != null && item.discount !== '') {
								discountStr = Globals.newFormatMiles(item.discount, decimals, '');
							}

							if (discountStr) {
								label_details += ` - ${discountStr}%`;
							}
							if (product.applied_discounts && product.applied_discounts.length > 0) {
								const names = product.applied_discounts.map(d => d.name).join(' + ');
								if (names) {
									label_details += ` (${names})`;
								}
							}

							const hasSpecialPrice = product.special_price_applied;
							let specialPriceLabel;
							if (hasSpecialPrice && product.special_price_limit != null && product.special_price_limit > 0 && parseFloat(qty) > parseFloat(product.special_price_limit)) {
								const specialQty = parseFloat(product.special_price_limit);
								const regularQty = parseFloat(qty) - specialQty;
								const specialPriceVal = product.original_special_price || product.special_price_limit_price || product.special_price;
								const regularPriceVal = product.original_price;

								specialPriceLabel = (
									<>
										{specialQty} x <span className="text-success font-weight-bold" title="Precio especial aplicado" style={{ cursor: 'help', borderBottom: '1px dotted #28a745' }}>{Globals.newFormatMiles(specialPriceVal, decimals)}</span>
										{' y '}
										{regularQty} x {Globals.newFormatMiles(regularPriceVal, decimals)}
									</>
								);
							} else if (hasSpecialPrice) {
								specialPriceLabel = (
									<>
										{qty} x <span className="text-success font-weight-bold" title="Precio especial aplicado" style={{ cursor: 'help', borderBottom: '1px dotted #28a745' }}>{Globals.newFormatMiles(price, decimals)}</span>
									</>
								);
							} else {
								specialPriceLabel = `${qty} x ${Globals.newFormatMiles(price, decimals)}`;
							}

							return (
								<div className="product-item" key={index}>
									<div className="product-image">
										<img src={Globals.fromPhotos(product?.photo?.file)} alt="Producto" />
									</div>
									<div className="product-info">
										<div className="product-name">{product?.name}</div>

										<div className="product-price">
											$ {Globals.newFormatMiles(rowSubtotal, decimals)} ({specialPriceLabel}{discountStr ? ` - ${discountStr}%` : ''}{this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && product.exento == Constants.PRODUCT_EXENTO.NO && item.iva != null ? ` + ${Globals.newFormatMiles(item.iva, decimals)} ${this.state.countryEquivalent.ivaAbbreviation}` : ''})
										</div>

										<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
											<Select
												label="Precio"
												className="material"
												value={parseFloat(item.selected_price)}
												options={this.getPrices(product)}
												onChange={e => this.changeValue(e.target.value, 'selected_price', index)}
											/>
											<Input
												type="text"
												label="Cantidad"
												className="material"
												value={item.quantity}
												onChange={e => this.changeValue(e.target.value, 'quantity', index)}
											/>
										</div>

										<div style={{ display: 'flex', flexDirection: 'column' }}>
											<label className="material" style={{ marginBottom: '5px' }}>Descuento (%)</label>
											<input
												type="text"
												placeholder="Opcional"
												className="form-control material"
												value={item.discount?.toString() || ''}
												onChange={e => {
													let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
													if ((value.match(/\./g) || []).length > 1) {
														value = value.substring(0, value.length - 1);
													}
													this.changeValue(value, 'discount', index);
												}}
											/>
										</div>
										{product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && (
											<div className="product-details">
												{item.color && <div className="product-color" style={{ backgroundColor: item.color?.hex }} />}
												{item.size && <div className="product-size">{item.size?.name}</div>}
											</div>
										)}
									</div>
								</div>
							)
						})}
					</div>

					<div className="totals" style={{ marginBottom: '1rem', padding: '0 1rem' }}>
						<div className="total-price">
							<div>SUBTOTAL:</div>
							<div>$ {Globals.newFormatMiles(this.state.original_subtotal_usd || this.state.form.subtotal, decimals)}</div>
						</div>
						{/* Descuentos por producto y globales - igual que la app */}
						{(this.state.appliedDiscountsRules || []).filter(i => i.name !== 'Precio Especial').map((item, idx) => (
							<div className="total-price" style={{ marginTop: '0.5rem' }} key={`disc-rule-${idx}`}>
								<div>{item.name.toUpperCase()}:</div>
								<div style={{ color: '#e74c3c' }}>-$ {Globals.newFormatMiles(item.totalAmount, decimals)}</div>
							</div>
						))}
						{this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && (
							<div className="total-price" style={{ marginTop: '0.5rem' }}>
								<div>{this.state.countryEquivalent.ivaAbbreviation}:</div>
								<div>$ {Globals.newFormatMiles(this.state.form.iva, decimals)}</div>
							</div>
						)}
						<div className="total-price" style={{ marginTop: '0.5rem' }}>
							<div>TOTAL:</div>
							<div>$ {Globals.newFormatMiles(this.state.form.total, decimals)}</div>
						</div>
					</div>

					<div className="form">
						<div className="tab-container">
							<div
								className={`tab ${this.state.form.status === Constants.PAYMENT_TYPES.PAID ? 'selected' : ''}`}
								onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.PAID)}
							>
								Pagado
							</div>
							<div
								className={`tab ${this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY ? 'selected' : ''}`}
								onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.TO_PAY)}
							>
								Por Cobrar
							</div>
						</div>

						{this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY && (
							<div className="row">
								<Input
									type="number"
									label="Pago Inicial"
									className="material flex-1"
									value={this.state.form.initial_payment}
									onChange={e => this.change(e.target.value, 'initial_payment')}
								/>
								<Input
									type="number"
									label="Días de Crédito"
									className="material flex-1"
									value={this.state.form.credit_days}
									onChange={e => this.change(e.target.value, 'credit_days')}
								/>
							</div>
						)}

						<div className="input-container">
							<Select
								label="Método de Pago"
								placeholder="Seleccionar"
								className="material"
								value={this.state.form.method_id}
								options={this.props.methods
									.filter(m => !this.state.methods_selected.find(s => s.id === m.id))
									.map(m => ({ value: m.id, label: m.name }))
								}
								onChange={e => {
									if (e.target.value) {
										this.setState({
											methods_selected: [...this.state.methods_selected, { id: e.target.value, amount: '' }],
											form: { ...this.state.form, method_id: '' }
										});
									}
								}}
							/>
						</div>

						{this.state.methods_selected.length > 0 && (
							<div className="container-payments">
								{this.state.methods_selected.map((i, index) => {
									const method = this.props.methods.find(item => item.id == i.id);

									return (
										<div className="payment-method">
											<div className="payment-method-desc">
												{method?.name}
											</div>
											<div className="payment-method-desc">
												<Input
													type="number"
													placeholder="Monto"
													labelClass="material"
													className="material"
													value={i.amount}
													onChange={e => {
														if (Globals.validateDouble(e.target.value) || e.target.value == '') {
															let methods_selected = [...this.state.methods_selected];
															methods_selected[index].amount = e.target.value;
															this.setState({
																methods_selected
															});
														}
													}}
												/>
											</div>
											<div className="payment-method-delete">
												<button
													onClick={() => {
														let methods_selected = [...this.state.methods_selected];
														methods_selected.splice(index, 1);
														this.setState({ methods_selected });
													}}
												>
													<img src={TrashIcon} style={{ width: 20, height: 20 }} alt="Eliminar" />
												</button>
											</div>
										</div>
									)
								})}
							</div>
						)}

						<div className="input-container" style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column' }}>
							<label className="material" style={{ marginBottom: '5px' }}>Descuento (%)</label>
							<input
								type="text"
								className="form-control material"
								value={this.state.form.discount_percentage}
								onChange={e => {
									let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
									if ((value.match(/\./g) || []).length > 1) {
										value = value.substring(0, value.length - 1);
									}
									this.change(value, 'discount_percentage');
								}}
							/>
						</div>

						{this.state.discountsRules && this.state.discountsRules
							.filter(master => master.type === 'general' && master.status === 1)
							.map((discount) => {
								const currentDiscount = this.state.form.general_discounts?.find(d => d.discount_id === discount.id);
								const currentValue = currentDiscount ? currentDiscount.value : '';
								return (
									<div className="input-container" style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column' }} key={`general-discount-input-${discount.id}`}>
										<label className="material" style={{ marginBottom: '5px' }}>{discount.name} %</label>
										<input
											type="text"
											className="form-control material"
											value={currentValue}
											onChange={e => {
												let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
												if ((value.match(/\./g) || []).length > 1) {
													value = value.substring(0, value.length - 1);
												}
												this.changeGeneralDiscount(discount.id, value);
											}}
										/>
									</div>
								);
							})
						}

						{appliedAutomaticDiscounts.length > 0 && (
							<div style={{ border: '2px solid #2874A6', borderRadius: '4px', padding: '10px', backgroundColor: '#eef2f7', width: '100%', marginTop: '1rem' }}>
								<label style={{ color: '#00204a', display: 'block', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
									Descuentos añadidos
								</label>
								<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
									{appliedAutomaticDiscounts.map((ad, idx) => (
										<div key={`auto-discount-${idx}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e2e9f3', color: '#333', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', fontWeight: '600' }}>
											<i className={`${ad.icon} mr-2`} style={{ color: '#6c757d', marginRight: '6px' }}></i>
											<span style={{ marginRight: '8px' }}>{ad.name}</span>
											{ad.percentage !== 'Especial' ? (
												<span style={{ backgroundColor: '#2874A6', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
													{ad.percentage}%
												</span>
											) : (
												<span style={{ backgroundColor: '#198754', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
													{ad.percentage}
												</span>
											)}
										</div>
									))}
								</div>
							</div>
						)}

						<div className="export-option" style={{ display: 'flex', alignItems: 'center', margin: '1rem 0' }}>
							<input
								id="tax-check"
								type="checkbox"
								checked={this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES}
								onChange={() => this.checkedChange(this.state.form.show_taxes !== Constants.QUOTES.SHOW_TAXES.YES)}
								style={{ marginRight: '10px' }}
							/>
							<label htmlFor="tax-check" style={{ marginBottom: 0 }}>Incluir Impuesto</label>
						</div>

						<Input
							label="Información adicional"
							className="material"
							multiline={true}
							value={this.state.form.information}
							onChange={e => this.change(e.target.value, 'information')}
						/>

						<div className="container-buttons" style={{ marginTop: '2rem' }}>
							<button
								className="btn-primary"
								onClick={() => {
									this.setState({ disabled_button: true });
									this.submit();
								}}
								disabled={this.state.disabled_button}
							>
								Finalizar Compra
							</button>
							<button className="btn-danger" onClick={() => this.props.onClose()}>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default connect(state => ({
	user: state.user,
	currency: state.currency,
}))(ConvertToOrder);